import {CloseButton, ProcessingView, TextCustom} from '@vw-marketing/us-components';
import {
  LayerCloseHandleV2,
  LayerRenderOptionsV2,
} from '@volkswagen-onehub/layer-manager';
import React from 'react';
import {formStatus, LayerContentState} from '../../typing/forms';
import {DEALER_FORM_CONFIGURATION, FORM_CONFIGURATION} from '../../utils/app-constants';
import { onVWBasicLayerCloseClick, onVWUsedVehicleFormLayerLoad } from '../../utils/tracking-helpers';
import Form from '../forms-components/form';
import FormikCustom from '../forms-components/formik-custom';
import ArrowLeft from '../icons/arrow-left';
import {
  getFieldsConfiguration,
  DEFAULT_MAKE_OFFER_FIELDS,
  formNameTextStyle,
  formBackTextStyle,
  formDescriptionTextStyle,
  DEFAULT_CONTACT_DEALER_FIELDS,
} from './helpers';
import {
  StyledModalFormContainer,
  StyledModalFormHeaderContainer,
} from './styles';

export interface ModalFormProps {
  state: LayerContentState;
  close: LayerCloseHandleV2<void>;
  options: LayerRenderOptionsV2;
}
export const ModalForm: React.FC<ModalFormProps> = (props) => {
  const {vehicle, formTranslation, zipData, serverConfig, formType} =
    props.state;
  const fields =
    formType === 'contact-dealer'
      ? DEFAULT_CONTACT_DEALER_FIELDS
      : DEFAULT_MAKE_OFFER_FIELDS;
  const fieldsConfiguration = getFieldsConfiguration(fields, vehicle, zipData);
  const formConfiguration = formType === "make-offer" ? FORM_CONFIGURATION : DEALER_FORM_CONFIGURATION;
  const [formState, setFormState] = React.useState<formStatus>('filling');
  const onHandleCloseButton = () => {
    onVWBasicLayerCloseClick(
      serverConfig.trackingManager,
      vehicle
    );
    props.close();
  };

  React.useEffect(() => {
    onVWUsedVehicleFormLayerLoad(
      serverConfig.trackingManager,
      formConfiguration,
      vehicle,
      formType === "contact-dealer"
    );
    return () => {

    }
  }, [])


  return (
    <StyledModalFormContainer>
      {formState === 'submitting' && <ProcessingView active={true} />}
      {formState === 'filling' && (
        <StyledModalFormHeaderContainer className="modal-header-content">
          <div className="form-close">
            <CloseButton onClick={onHandleCloseButton} />
          </div>
          <div className="form-name">
            <TextCustom {...formNameTextStyle}>
              {formTranslation.formName}
            </TextCustom>
          </div>
          <div className="form-back" onClick={onHandleCloseButton}>
            <ArrowLeft iconSize={20} />{' '}
            <TextCustom {...formBackTextStyle}>
              {' '}
              {formTranslation.backCtaLabel}
            </TextCustom>
          </div>

          <div className="form-description">
            <TextCustom {...formDescriptionTextStyle}>
              {formTranslation.description}
            </TextCustom>
          </div>
        </StyledModalFormHeaderContainer>
      )}
      <FormikCustom
        setFormState={setFormState}
        vehicle={vehicle}
        fieldsConfiguration={fieldsConfiguration}
        formConfiguration={formConfiguration}
        serverConfig={serverConfig}
      >
        <Form
          formState={formState}
          setFormState={setFormState}
          translations={formTranslation}
          vehicle={vehicle}
          onCloseHandle={onHandleCloseButton}
          fieldsConfiguration={fieldsConfiguration}
          faHostServerUrl={serverConfig.faHostServerUrl}
        />
      </FormikCustom>
    </StyledModalFormContainer>
  );
};
